__turbopack_context__.v({
  "donationAttribution": "AttributionModal-module__dAZtdG__donationAttribution",
  "modal": "AttributionModal-module__dAZtdG__modal",
});
